<template>
    <div>
        <b-container>
            <b-row no-gutters align-content="center">
                <b-row no-gutters align-content="center" style="margin:0.9rem;width:100%">
                    <b-col cols="12" class="Display">{{UserDigitDisplay}}</b-col>
                </b-row>
                <b-col cols="4" v-for="i in DisplayNumberFormat">
                    <b-button id="PinButton" @click="HandlePin(i)">{{i}}</b-button>
                </b-col>
            </b-row>
            <b-row no-gutters align-content="center">
                <b-col cols="8"><b-button id="PinButtonZero" @click="HandlePin(0)">0</b-button></b-col>
                <b-col cols="4"><b-button id="PinButton" @click="DeletePin()">DEL</b-button></b-col>
            </b-row>
        </b-container>
        <b-modal ref="correct-modal" hide-footer title="You have entered the correct pin.">
            <div class="d-block text-center">
                <h3>SUCCESS!</h3>
            </div>
            <b-button class="mt-2" variant="outline-warning" block @click="hideModal('correct-modal')">Continue</b-button>
        </b-modal>
        <b-modal ref="incorrect-modal" hide-footer title="You have entered the wrong pin.">
            <div class="d-block text-center">
                <h3>TRY AGAIN!</h3>
            </div>
            <b-button class="mt-2" variant="outline-warning" block @click="hideModal('incorrect-modal')">Continue</b-button>
        </b-modal>
    </div>

</template>

<script>

    export default {
        props: [
            "DigitLength",
            "AdditionalPayload",
            "AuthenticateMethod",
            "DisplayNumbers",
            "RedirectTo",
            "DisplayAlertMessage"
        ],
        data: function () {
            return {
                DisplayPin: "",
                DisplayNumberFormat: [7,8,9,4,5,6,1,2,3]
            };
        },
        created() {
            //Listener for 0-9 for both numpad and keyboard
            document.addEventListener('keydown', this.ProcessKeyEntry);
        },
        destroyed() {
            document.removeEventListener('keydown', this.ProcessKeyEntry);
        },
        methods: {
            ProcessKeyEntry(e) {
                if ((e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105)) {
                    this.HandlePin(e.key);
                }
                if (event.key === "Backspace" || event.key === "Delete") {
                    this.DeletePin();
                }
            },
            hideModal(name) {
                this.$refs[name].hide()
            },
            DigitsFilled() {
                //this.AdditionalPayload.DisplayPin = this.DisplayPin;
                let finalPayload = { ...{Pin: this.DisplayPin} , ...this.AdditionalPayload };
                //loop through Panes shown and flip true/false values
                this.$MasterAPI.ExecuteRequest("POST", this.AuthenticateMethod, finalPayload, this.DigitsFilledSuccess, this.DigitsFilledError, true);
            },
            DigitsFilledSuccess(response) {
                if (this.RedirectTo != undefined) {
                    window.location.href = this.RedirectTo;
                }
                else if (this.DisplayAlertMessage != undefined) {
                    alert(this.DisplayAlertMessage);
                    this.$parent.$parent.$parent.HidePinModal();
                }
            },
            DigitsFilledError(response) {
                this.DisplayPin = "";
                this.$emit('update')
            },
            HandlePin(e) {
                if (this.DigitsEntered < this.DigitLength) {
                    this.DisplayPin = this.DisplayPin + e;
                }

                if (this.DigitsEntered >= this.DigitLength) {
                    this.DigitsFilled();
                }
            },
            DeletePin() {
                this.DisplayPin = (this.DisplayPin).slice(0, this.DisplayPin.length - 1);
            }
        },
        computed: {
            DigitsEntered: function () {
                return this.DisplayPin.length;
            },
            UserDigitDisplay: function () {
                if (this.DisplayNumbers == true) {
                    return this.DisplayPin;
                } else {
                    return "*".repeat(this.DigitsEntered);
                }
            }
        },
    }
</script>

<style scoped>
    .Display {
        background: #ededed;
        width: 92%;
        height: 100px;
        font-size: 4em;
        text-align: center;
        border: 1px solid #d5d5d5;
    }

    #PinButton {
        margin: 0.9rem;
        width: 90%;
        padding: 10%;
        font-size: 200%;
    }

    #PinButtonZero {
        margin: 0.9rem;
        width: 95%;
        padding: 5%;
        font-size: 200%;
    }
</style>